import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AppLayout from '../AppLayout';
import { updateUsuario, getUsuario, listRol, listMarketplace } from '../../Api';
import FormErrors from '../FormErrors'

class UsuarioForm extends Component {
  state = {
    email: "",
    name: "",
    blocked: true,
    roles_id: 0,
    roles: [],
    marketplace: null,
    error: {},
    marketplaces: []
  };

  async componentDidMount() {
    const roles = await listRol(this.props.usuario.token)
    this.props.dispatch({
      type: 'setRol',
      payload: roles
    })

    let marketplaces = await listMarketplace(this.props.usuario.token)
    marketplaces = marketplaces || []

    if (this.props.match && this.props.match.params && this.props.match.params.id) {
      const { id } = this.props.match.params;
      const { email, rol, name, blocked, marketplace } = await getUsuario(id, this.props.usuario.token)

      let marketplace_list = {}
      marketplaces.forEach(element => {
        marketplace_list[element._id] = element
      });
      if (Object.keys(marketplace_list).length > 0)
        marketplace.forEach(element => {
          if (marketplace_list[element._id])
            marketplace_list[element._id].checked = true
        })

      this.setState({ email, id, rol, name, blocked, marketplaces: marketplace_list })
    } else {
      alert('Usuario no existe')
      this.props.history.push('/users')
    }
  }

  handleSubmit = async event => {
    event.preventDefault();
    let marketplaces = Object.entries(this.state.marketplaces)
      .filter(([key, market]) => {
        return market.checked
      })
    if (marketplaces.length > 0) {
      marketplaces = marketplaces.map(([key, market]) => {
        return market._id
      })
    }
    await this.update({
      id: this.state.id,
      email: this.state.email,
      rol: this.state.rol,
      blocked: this.state.blocked,
      name: this.state.name,
      marketplace: marketplaces,
    })
  };

  async update(usuario) {
    try {
      const res = await updateUsuario(usuario, this.props.usuario.token);
      if (res._id) {
        this.props.history.push('/users');
      } else if (res.error) {
        const { message } = res.error;
        alert(message);
      } else {
        alert(JSON.stringify(res))
      }
    } catch (error) {
      if (typeof error === 'string') {
        this.setState({ error: { name: 'Error', message: error } })
      } else {
        this.setState({ error })
      }
    }
  }

  onInputChange = event => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const id = target.id;
    if (!id && target.classList.contains('marketplace')) {
      const marketplaces = this.state.marketplaces;
      marketplaces[target.value].checked = value;
      this.setState({ marketplaces });
    } else {
      this.setState({ [id]: value });
    }
  };

  render() {
    return (
      <AppLayout>
        <h1>Usuario</h1>
        <form className='form'>
          <FormErrors {...this.state.error} />
          <div className='form-group'>
            <label htmlFor="name">Nombre</label>
            <input className="form-control disabled" type="text" id='name' placeholder="Nombre"
              value={this.state.name} onChange={this.onInputChange} />
          </div>
          <div className='form-group'>
            <label htmlFor="email">Email</label>
            <input className="form-control disabled" type="text" id='email' placeholder="Email"
              value={this.state.email} disabled onChange={this.onInputChange} />
          </div>
          <div className='checkbox'>
            <label className="">
              <input disabled={this.props.readOnly}
                className="checkbox" type="checkbox" id='blocked'
                checked={this.state.blocked} onChange={this.onInputChange} />
              Bloqueado
            </label>
          </div>
          <div className='form-group'>
            <label htmlFor="rol">Rol</label>
            <select
              value={this.state.rol}
              className="form-control"
              onChange={this.onInputChange}
              id='rol'>
              {this.props.roles.map(item => {
                return (<option key={`${item}`} value={item}>{item}</option>)
              })}
            </select>
          </div>
          <div className='form-group'>
            <label htmlFor="marketplace">Plaza</label>
            {Object.entries(this.state.marketplaces).map(([key, item]) => {
              return (<div className='inline-block' key={`${item._id}`}>
                <label className="">
                  <input disabled={this.props.readOnly}
                    className="checkbox marketplace"
                    type="checkbox"
                    value={item._id}
                    checked={item.checked}
                    onChange={this.onInputChange}
                  /> {item.name}</label>
              </div>)
            })}
          </div>
          <button type="submit" className="btn btn-primary" onClick={this.handleSubmit}>Guardar</button>
        </form>
      </AppLayout>
    );
  }
}

const mapStoreToProps = (state, props) => {
  return {
    ...props,
    usuario: state.usuario,
    roles: state.roles,
    marketplaces: state.marketplaces,
  }
}
export default withRouter(connect(mapStoreToProps)(UsuarioForm));